/**************************************************************************************************/
/** @export Enum @name LoginTypes                                                                **/
/**************************************************************************************************/
export enum LoginTypes
{
	Storage,
	User
}